import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx'; // Original app with authentication
import { ErrorBoundary } from './components/ErrorBoundary';
import { watchForAppUpdate } from './services/appUpdateRecovery';
// import TestApp from './TestApp.jsx' // Simple test page
import './styles/index.css';
import { ThemeProvider, createTheme, CssBaseline } from '@mui/material';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient, setupQueryPersistence } from './libs/queryClient';

const appTheme = createTheme({
  components: {
    MuiTextField: { defaultProps: { variant: 'outlined', size: 'small' } },
    MuiSelect: { defaultProps: { variant: 'outlined', size: 'small' } },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          backgroundColor: '#ffffff',
          '& .MuiOutlinedInput-notchedOutline': { borderColor: '#0f172a', borderWidth: 2 },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#111827' },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#2563eb', borderWidth: 2 },
          '&.Mui-disabled': { backgroundColor: '#f1f5f9' }
        }
      }
    }
  }
});

setupQueryPersistence();
watchForAppUpdate();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={appTheme}>
        <CssBaseline />
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </ThemeProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
